import { render, staticRenderFns } from "./OrgInviteForm.vue?vue&type=template&id=6eeb3016&"
import script from "./OrgInviteForm.vue?vue&type=script&lang=js&"
export * from "./OrgInviteForm.vue?vue&type=script&lang=js&"
import style0 from "./OrgInviteForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports